import React from 'react';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import Label from 'components/form/Label/Label';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import InsuranceTypeBadge from '../../../../pages/Marketplace/pages/InsuranceMarketplace/components/InsuranceTypeBadge/InsuranceTypeBadge';
import { ReactComponent as AutoInsuranceIcon } from 'style/_assets/icons/marketplace/art-autoinsurance.svg';
import { ReactComponent as HomeInsuranceIcon } from 'style/_assets/icons/marketplace/art-homeinsurance.svg';
import { ReactComponent as LifeInsuranceIcon } from 'style/_assets/icons/marketplace/art-lifeinsurance.svg';
import {
  FEATURE_NAME_HOME_INSURANCE,
  FEATURE_NAME_AUTO_INSURANCE,
  FEATURE_NAME_LIFE_INSURANCE,
} from 'types/highlightFeatures.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';

import {
  AUTO_INSURANCE_VERTICAL_CARD,
  HOME_INSURANCE_VERTICAL_CARD,
  AUTO_INSURANCE_VERTICAL,
  HOME_INSURANCE_VERTICAL,
  LIFE_INSURANCE_VERTICAL_CARD,
  LIFE_INSURANCE_VERTICAL,
  AUTO_INSURANCE_VERTICAL_VRI,
  HOME_INSURANCE_VERTICAL_VRI,
  LIFE_INSURANCE_VERTICAL_VRI,
} from 'types/marketplaceTiles.constants';
import { useLinkHandler } from 'hook/event.hook';
import { INSURANCE_MARKETPLACE } from 'types/morph.pagePosition.constants';
import { useVri } from 'pages/Marketplace/offerPageContainer.hook';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { HOME_INSURANCE_PERSONAL_URL } from 'types/mrph.routes.constants';
import { Image } from 'components/Image/Image';

const InsuranceTilesView = props => {
  const datatestid = 'InsuranceMarketplace';
  const onLinkClickCallback = useLinkHandler(props.eventHandler);
  return props.tileOffers.map((item, index) => {
    return (
      <InsuranceTypeBadge
        key={index}
        onLinkClickCallback={onLinkClickCallback}
        text={item.text}
        icon={item.icon}
        featureToHighlight={item.featureToHighlight}
        offerModulePosition={index + 1}
        cardName={item.cardName}
        modulePosition={props.modulePosition}
        vertical={item.vertical}
        location={item.location}
        url={item.url}
        datatestid={`${datatestid}-${item.datatestid}`}
      />
    );
  });
};

const InsuranceMarketplaceTilesView = props => {
  useViewModule(props.trackingAtr);
  const seenPixel = useSeenModulePixel(props.trackingAtr);
  return (
    <PageContainer className="cs-insurance-landing">
      {seenPixel}
      <SectionContainer>
        <Row>
          <Label
            datatestid={'ssn-verify-desktop'}
            className="mobileHide"
            type="H3"
            typeHeader={'h2'}
          >
            What type of insurance are you looking for?
          </Label>
          <Label
            datatestid={'ssn-verify-mobile'}
            className="desktopHide"
            type="H5"
            typeHeader={'h2'}
          >
            What type of insurance are you looking for?
          </Label>
        </Row>
        <Row>
          <FlexContainer className="m-flex-column flex-container">
            <InsuranceTilesView {...props} tileOffers={props.finalOfferTiles} />
          </FlexContainer>
        </Row>
      </SectionContainer>
    </PageContainer>
  );
};

const InsuranceMarketplaceTilesModule = props => {
  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: INSURANCE_MARKETPLACE,
    modulePosition: props.modulePosition,
    vertical: 'Insurance',
  });

  const tileOffers = [
    {
      text: 'I want auto insurance',
      icon: (
        <Image
          imgClass="auto_insurance_icon-dashboard"
          className={'width48px height48px'}
        />
      ),
      url: '/offers?vertical=AUTO_INSURANCE',
      location: 'offers-insurance-auto',
      featureToHighlight: FEATURE_NAME_AUTO_INSURANCE,
      cardName: AUTO_INSURANCE_VERTICAL_CARD,
      vertical: AUTO_INSURANCE_VERTICAL,
      datatestid: 'auto-insurance',
      vriName: AUTO_INSURANCE_VERTICAL_VRI,
    },
    {
      text: 'I want home insurance',
      icon: (
        <Image
          imgClass="home_insurance_icon-dashboard"
          className={'width48px height48px'}
        />
      ),
      url: HOME_INSURANCE_PERSONAL_URL,
      location: 'offers-insurance-home',
      featureToHighlight: FEATURE_NAME_HOME_INSURANCE,
      cardName: HOME_INSURANCE_VERTICAL_CARD,
      vertical: HOME_INSURANCE_VERTICAL,
      datatestid: 'home-insurance',
      vriName: HOME_INSURANCE_VERTICAL_VRI,
    },
    {
      text: 'I want life insurance',
      icon: (
        <Image
          imgClass="life_insurance_icon-dashboard"
          className={'width48px height48px'}
        />
      ),
      url: '/offers?vertical=LIFE_INSURANCE',
      location: 'offers-insurance-life',
      featureToHighlight: FEATURE_NAME_LIFE_INSURANCE,
      cardName: LIFE_INSURANCE_VERTICAL_CARD,
      vertical: LIFE_INSURANCE_VERTICAL,
      datatestid: 'life-insurance',
      vriName: LIFE_INSURANCE_VERTICAL_VRI,
    },
  ];
  const { finalOfferTiles, loadingVri } = useVri(tileOffers, props.userInfo);

  const loading = props.globalLoadingFlag || loadingVri;

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <InsuranceMarketplaceTilesView
        trackingAtr={trackingAtr}
        finalOfferTiles={finalOfferTiles}
        {...props}
      />
    );
  }
};

export default InsuranceMarketplaceTilesModule;
